import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface ListItem {
  id: number
  customer_id: number | null
  customer: string | null
  customer_user: string | null
  status: number
}
interface Activity {
  id: number
  title: string
}
interface Props {
  activity: Activity
  list_items: ListItem[]
}

export default function Index({ activity, list_items }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Activities", href: "/marketing_activities" },
    { title: activity.title, href: `/marketing_activities/${activity.id}` },
    {
      title: "Attendees",
      href: `/marketing_activities/${activity.id}/list_items`,
    },
  ]
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`${activity.title} - Attendees`} />
      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">
            Attendees for {activity.title}
          </h1>
          <div className="flex gap-2">
            <Link
              href={`/marketing_activities/${activity.id}/list_items/quick_add`}
              className="bg-hpi-dark-green hover:bg-hpi-med-green rounded px-4 py-2 text-white"
            >
              Quick Add
            </Link>
            <Link
              href={`/marketing_activities/${activity.id}/list_items/new`}
              className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
            >
              Add Customer
            </Link>
          </div>
        </div>
        {list_items.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border px-4 py-2 text-left">Customer</th>
                <th className="border px-4 py-2 text-left">Contact</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {list_items.map((item) => (
                <tr key={item.id}>
                  <td className="border px-4 py-2">{item.customer}</td>
                  <td className="border px-4 py-2">{item.customer_user}</td>
                  <td className="border px-4 py-2">
                    <div className="flex items-center gap-3">
                      {item.customer_id && (
                        <Link
                          href={`/marketing_activities/${activity.id}/list_items/add_contact?customer_id=${item.customer_id}`}
                          className="text-hpi-dark-green hover:underline"
                        >
                          Add Contact
                        </Link>
                      )}
                      <Link
                        href={`/marketing_activities/${activity.id}/list_items/${item.id}`}
                        method="delete"
                        as="button"
                        className="text-hpi-red"
                      >
                        Remove
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No customers in list.</p>
        )}
      </div>
    </AppLayout>
  )
}
